<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="700px"
    >
      <v-form
        ref="form"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span style="font-size: 20px; font-weight: 500;">Notes Curtainwall Schedule #{{ schedule ? schedule.id : '' }}</span>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-if="isAddBtn"
                class="text-end"
              >
                <v-btn
                  color="primary"
                  outlined
                  @click="addNew"
                >
                  <v-icon
                    small
                    class="mr-1"
                  >
                    fas fa-plus
                  </v-icon>
                  New Note
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!isAddBtn">
              <v-col class="pb-0">
                <v-textarea
                  v-model="item.text"
                  outlined
                  rows="3"
                  :rules="[(v) => !!(v && v.trim()) || 'Note is required']"
                >
                  <template slot="label">
                    Note<RedAsterisk />
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="!isAddBtn">
              <v-col class="text-end pt-0 pb-0">
                <v-btn
                  color="normal"
                  class="mr-2"
                  @click="isAddBtn = true"
                >
                  Cancel
                </v-btn>
                <v-btn
                  :disabled="disableSubmitBtn"
                  :loading="disableSubmitBtn"
                  color="primary"
                  @click="submit"
                >
                  SUBMIT
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!isAddBtn">
              <v-col class="pb-0 pt-0 ">
                <zig-zag />
              </v-col>
            </v-row>
            <v-row v-if="schedule && schedule.notes.length > 0">
              <v-col>
                <v-row>
                  <v-col>
                    <v-card-text style="max-height: 300px; overflow-y: auto; border: 1px solid #d3d3d3; border-radius: 3px;">
                      <v-list two-line>
                        <template v-for="(note, index) in schedule.notes">
                          <v-list-item :key="note.id">
                            <!-- Display each note -->
                            <v-list-item-content>
                              {{ note.text }}
                              <v-list-item-subtitle style="padding-top: 10px;">{{ note.created_at }}</v-list-item-subtitle>
                              <v-list-item-subtitle>{{ `${note.user.first_name ? note.user.first_name : ''} ${note.user.last_name ? note.user.last_name : ''}` }}</v-list-item-subtitle>
                            
                            </v-list-item-content>
                            <!-- <v-divider v-if="index !== schedule.notes.length - 1"/> -->
                          </v-list-item>
                          <v-divider
                            v-if="index < schedule.notes.length - 1"
                            :key="index"
                          ></v-divider>
                        </template>
                      </v-list>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="normal"
              class="mr-2"
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import ZigZag from '@/components/elements/ZigZag';

export default {
  components: {
    ZigZag,
  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      text: '',
      commercial_schedule_id: null,
    },
    dialog: false,
    schedule: null,
    isAddBtn: true,
    disableSubmitBtn: false,
  }),
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async getSchedule(id) {
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.commercialSchedule.read(submitModel);
      const firstIndex = 0;
      if (!res || !res.data || !res.data[firstIndex]) return;
      this.schedule = res.data[firstIndex];
      this.item.text = this.schedule.last_note;
    },

    async submit() {
      if (this.disableSubmitBtn) return;
      this.disableSubmitBtn = true;
      if (!this.$refs.form.validate()) {
        this.disableSubmitBtn = false;
        return;
      }
      const text = this.item.text ? this.item.text.trim() : '';
      if (!text) {
        this.disableSubmitBtn = false;
        return;
      }
      this.item.text = text;
      const res = await this.$api.commercialScheduleNote.store(this.item);

      if (!res) {
        this.disableSubmitBtn = false;
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.getSchedule(this.item.commercial_schedule_id);
      this.item.text = '';
      this.isAddBtn = true;
      this.disableSubmitBtn = false;
      this.$emit('success');
    },

    addNew() {
      this.item.text = '';
      this.isAddBtn = false;
    },

    open(id) {
      this.isAddBtn = true;
      this.item.commercial_schedule_id = id;
      this.getSchedule(id);
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
::v-deep .wrap-text {
  white-space: normal !important;
  max-height: 68px;
  overflow-y: auto;
}
</style>
